import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ADMIN_ROUTES } from "../utils/router";
import { CustomRoute } from "routes";

export const useSidebar = (isAdmin: boolean) => {
  const { pathname } = useLocation();

  const DEFAULT_LOCATION = isAdmin ? "/" : "/friends";
  const MAIN_TABS = Object.values(ADMIN_ROUTES)
    .filter((route) => route.show && Array.isArray(route.children))
    .flatMap((route: CustomRoute) =>
      route.children!.filter((child) => child.show).map((child) => child.path)
    );

  const [location, setLocation] = useState(() => {
    if (MAIN_TABS.includes(pathname)) {
      return pathname;
    }
  });

  const onLocationSelect = (newLocation: string) => {
    setLocation(newLocation);
  };

  useEffect(() => {
    if (MAIN_TABS.includes(pathname)) {
      setLocation(pathname);
    }
  }, [pathname, MAIN_TABS]);

  return {
    models: {
      location,
      DEFAULT_LOCATION,
    },
    operations: {
      onLocationSelect,
    },
  };
};
